export class OrderSubLocationHistory {
  subLocationID?: number;
  subLocationName?: string;
  onHand?: number;
  quantityToOrder?: number;
  notes?: string;
}

export class MaterialSubLocationHistory {
  material?: string;
  loc?: string;
  company?: number;
  subLocations?: OrderSubLocationHistory[];
}
